export const PurchaseOrderDeliValidation = (formData) => {
    const errors = {};
   
    if (!formData.deliv_FullName || formData.deliv_FullName==="") {
        errors.deliv_FullName = 'This field is required';
    }
    if (!formData.deliv_Address1 || formData.deliv_Address1==="") {
        errors.deliv_Address1 = 'This field is required';
    }
    if (!formData.deliv_Town || formData.deliv_Town==="") {
        errors.deliv_Town = 'This field is required';
    }
    if (!formData.deliv_County || formData.deliv_County=="") {
        errors.deliv_County = 'This field is required';
    } 
    if (!formData.deliv_Telephone || formData.deliv_Telephone=="") {
        errors.deliv_Telephone = 'This field is required';
    } 
    if (!formData.deliv_PostCode || formData.deliv_PostCode=="") {
        errors.deliv_PostCode = 'This field is required';
    } 
    if (!formData.deliv_Country || formData.deliv_Country=="0") {
        errors.deliv_Country = 'This field is required';
    } 
    return errors;
};
